var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-sidebar', {
    attrs: {
      "shadow": "lg",
      "right": "",
      "width": "50%",
      "bg-variant": "white",
      "title": "Create Maintenance & Docking Plan"
    },
    on: {
      "toggle": function toggle($event) {
        _vm.show.form = !_vm.show.form;
      }
    },
    model: {
      value: _vm.show.form,
      callback: function callback($$v) {
        _vm.$set(_vm.show, "form", $$v);
      },
      expression: "show.form"
    }
  }, [_vm.show.form ? [_vm.show.form ? _c('FormTargetFleetAvailabilityYearly', {
    attrs: {
      "showForm": _vm.show.form,
      "forms": _vm.form
    },
    on: {
      "refetch": _vm.onSuccessSubmit
    }
  }) : _vm._e()] : _vm._e()], 2), _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center my-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-input', {
    staticClass: "mx-2",
    staticStyle: {
      "max-width": "220px"
    },
    attrs: {
      "placeholder": "Fleet Name..."
    },
    model: {
      value: _vm.params.search,
      callback: function callback($$v) {
        _vm.$set(_vm.params, "search", $$v);
      },
      expression: "params.search"
    }
  }), _c('v-multiselect', {
    staticClass: "mr-2",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "Fleet Type",
      "label": "name",
      "options": _vm.optionsFleetTypes,
      "multiple": true,
      "required": "",
      "track-by": "id"
    },
    model: {
      value: _vm.params.vehicle_type_ids,
      callback: function callback($$v) {
        _vm.$set(_vm.params, "vehicle_type_ids", $$v);
      },
      expression: "params.vehicle_type_ids"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Fleet type not found.")])]), _c('date-picker', {
    staticClass: "mr-2",
    attrs: {
      "type": "year"
    },
    model: {
      value: _vm.params.year,
      callback: function callback($$v) {
        _vm.$set(_vm.params, "year", $$v);
      },
      expression: "params.year"
    }
  }), _c('b-button', {
    staticClass: "w-100",
    staticStyle: {
      "height": "max-content",
      "max-width": "100px"
    },
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click() {
        return _vm.fetchData();
      }
    }
  }, [_vm._v(" Apply Filter ")])], 1), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center",
    attrs: {
      "md": "3"
    }
  }, [_c('b-button', {
    staticClass: "text-truncate mr-2",
    staticStyle: {
      "height": "max-content"
    },
    attrs: {
      "disabled": _vm.loadingExport,
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.handleExportTargetAv
    }
  }, [_vm.loadingExport ? _c('b-spinner', {
    staticClass: "mr-1",
    staticStyle: {
      "width": "16px",
      "height": "16px"
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.loadingExport ? 'Loading...' : 'Export Plan By Fleet') + " ")], 1), _c('b-dropdown', {
    staticClass: "m-2",
    attrs: {
      "id": "dropdown-left",
      "text": "Data Plan",
      "variant": "primary"
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        _vm.show.form = true, _vm.selectedData = null;
      }
    }
  }, [_vm._v("Create Data Plan")]), _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        _vm.showModal = true;
      }
    }
  }, [_vm._v("Import Data Plan")])], 1)], 1)]), !_vm.loading ? [_c('div', {
    staticClass: "overflow-auto relative w-100"
  }, [_c('table', {
    staticClass: "w-100 striped-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "p-2 align-middle text-center text-black",
    staticStyle: {
      "background-color": "#F2F2F2"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Action")]), _c('th', {
    staticClass: "p-2 align-middle text-center text-black",
    staticStyle: {
      "background-color": "#F2F2F2",
      "min-width": "150px"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Fleet Name")]), _vm._l(_vm.months, function (month, idx) {
    return _c('th', {
      key: month,
      staticClass: "p-2 align-middle text-center text-dark",
      style: {
        backgroundColor: _vm.monthColors[idx % _vm.monthColors.length]
      },
      attrs: {
        "colspan": 3
      }
    }, [_vm._v(" " + _vm._s(month.toUpperCase()) + " ")]);
  })], 2), _c('tr', [_vm._l(_vm.months, function (month, idx) {
    return [_c('th', {
      key: month + '-sub-availability',
      staticClass: "p-2 text-center text-black",
      style: {
        backgroundColor: _vm.monthColors[idx % _vm.monthColors.length]
      }
    }, [_vm._v("Plan Availability")]), _c('th', {
      key: month + '-sub-breakdown',
      staticClass: "p-2 text-center text-black",
      style: {
        backgroundColor: _vm.monthColors[idx % _vm.monthColors.length]
      }
    }, [_vm._v("Plan Breakdown")]), _c('th', {
      key: month + '-sub-docking',
      staticClass: "p-2 text-center text-black",
      style: {
        backgroundColor: _vm.monthColors[idx % _vm.monthColors.length]
      }
    }, [_vm._v("Plan Docking")])];
  })], 2)]), _c('tbody', _vm._l(_vm.listPlanAvailabilities, function (fleet, idx) {
    return _c('tr', {
      key: idx
    }, [_c('td', {
      staticClass: "text-center py-2"
    }, [_c('b-dropdown', {
      staticClass: "m-2",
      attrs: {
        "id": "dd-".concat(idx),
        "text": "Action",
        "variant": "outline-primary"
      }
    }, [_c('b-dropdown-item', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function click() {
          return _vm.handleUpdate(fleet);
        }
      }
    }, [_vm._v("Update Plan")]), _c('b-dropdown-item', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function click() {
          return _vm.handleDelete(fleet);
        }
      }
    }, [_vm._v("Delete Plan")])], 1)], 1), _c('td', [_c('span', {
      staticClass: "badge badge-info p-2"
    }, [_vm._v(_vm._s(fleet.vehicle.name))])]), _vm._l(fleet.plan_data, function (month, idx) {
      return [_c('td', {
        key: fleet.id + '-availability-' + idx,
        staticClass: "text-center p-2",
        staticStyle: {
          "min-width": "200px"
        }
      }, [_vm._v(_vm._s(parseFloat(month.plan_availability || 0).toFixed(2)) + "%")]), _c('td', {
        key: fleet.id + '-breakdown-' + idx,
        staticClass: "text-center p-2",
        staticStyle: {
          "min-width": "200px"
        }
      }, [_vm._v(_vm._s(parseFloat(month.plan_breakdown || 0).toFixed(2)) + "%")]), _c('td', {
        key: fleet.id + '-docking-' + idx,
        staticClass: "text-center p-2",
        staticStyle: {
          "min-width": "200px"
        }
      }, [_vm._v(_vm._s(parseFloat(month.plan_docking || 0).toFixed(2)) + "%")])];
    })], 2);
  }), 0)])]), _c('div', {
    staticClass: "mt-4 d-flex align-items-center w-100 justify-content-end"
  }, [_c('b-pagination', {
    staticClass: "mb-0 mr-3",
    attrs: {
      "total-rows": _vm.meta.totalItems,
      "per-page": _vm.meta.perPage,
      "first-number": "",
      "align": "center"
    },
    on: {
      "change": function change(page) {
        _vm.meta.page = page;
        _vm.fetchData();
      }
    },
    model: {
      value: _vm.meta.page,
      callback: function callback($$v) {
        _vm.$set(_vm.meta, "page", $$v);
      },
      expression: "meta.page"
    }
  }), _c('b-form-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "plain": "",
      "options": _vm.limitOptions
    },
    on: {
      "input": _vm.fetchData
    },
    model: {
      value: _vm.meta.perPage,
      callback: function callback($$v) {
        _vm.$set(_vm.meta, "perPage", $$v);
      },
      expression: "meta.perPage"
    }
  })], 1)] : _c('div', {
    staticClass: "d-flex justify-content-center p-5 w-100",
    attrs: {
      "colspan": "17"
    }
  }, [_c('b-spinner')], 1)], 2), _c('b-modal', {
    attrs: {
      "title": "Import Data",
      "ok-title": "Submit",
      "loading": _vm.loadingImport
    },
    on: {
      "ok": _vm.handleimportTargetAv
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "text-primary"
        }, [_vm._v("Import Data")]), _c('i', {
          staticClass: "fa fa-times cursor-pointer",
          on: {
            "click": function click($event) {
              _vm.showModal = false;
            }
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showModal,
      callback: function callback($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [[_c('div', {
    staticClass: "flex flex-column align-items-center"
  }, [_c('b-form-file', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": ".xlsx, .xls, .csv"
    },
    model: {
      value: _vm.importFile,
      callback: function callback($$v) {
        _vm.importFile = $$v;
      },
      expression: "importFile"
    }
  }), _c('small', {
    staticClass: "text-black"
  }, [_vm._v("accept: .xlsx, .xls, .csv")])], 1), !_vm.loadingExportTemplate ? _c('b-button', {
    staticClass: "mt-3 w-100",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.handleExportTemplateAv
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download Template ")]) : _c('b-button', {
    staticClass: "mt-3 w-100",
    attrs: {
      "variant": "outline-primary"
    }
  }, [_c('b-spinner', {
    staticClass: "mr-2",
    staticStyle: {
      "width": "18px",
      "height": "18px"
    }
  }), _vm._v(" Downloading ")], 1)]], 2), _c('b-modal', {
    attrs: {
      "title": "Import Error Information",
      "ok-only": ""
    },
    model: {
      value: _vm.showErrImport,
      callback: function callback($$v) {
        _vm.showErrImport = $$v;
      },
      expression: "showErrImport"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow": "auto",
      "max-height": "70vh"
    }
  }, [_c('table', {
    staticClass: "w-100"
  }, [_c('thead', [_c('th', {
    staticClass: "p-2",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Row Number")]), _c('th', {
    staticClass: "p-2"
  }, [_vm._v("Message")])]), _c('tbody', [_vm.msgErrImport.length ? _vm._l(_vm.msgErrImport, function (item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "p-2 px-4"
    }, [_vm._v(_vm._s(item.rowNumber))]), _c('td', {
      staticClass: "p-2"
    }, [_vm._v(_vm._s(item.message))])]);
  }) : _vm._e()], 2)])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }